import _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  public modalRef: MdbModalRef<any> = null;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }


  getSurvey() {
    const queryParams = [
      `access_token=${this.cookieService.get('accessToken')}`
    ];
    const adminAccessToken = this.cookieService.get('adminAccessToken');
    if(adminAccessToken) {
      queryParams.push(`admin_user_access_token=${adminAccessToken}`)
    }
    return this.http.post('/api/nps/ifRequired', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getSurveyRecord(params) {
    const queryParams = [
      `access_token=${this.cookieService.get('accessToken')}`
    ];
    const adminAccessToken = this.cookieService.get('adminAccessToken');
    if(adminAccessToken) {
      queryParams.push(`admin_user_access_token=${adminAccessToken}`)
    }
    queryParams.push(`p=${encodeURIComponent(JSON.stringify(params))}`)
    return this.http.post('/api/nps/record', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}